import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const MultiLanguage = makeShortcode("MultiLanguage");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Linking events to specific users enables you to gain full insights as to how they're using your product across different sessions, devices, and platforms. `}</p>
    <p>{`This is straight forward to do when `}<a parentName="p" {...{
        "href": "/docs/getting-started/send-events#3-capture-backend-events"
      }}>{`capturing backend events`}</a>{`, as you associate events to a specific user using `}<inlineCode parentName="p">{`distinct_id`}</inlineCode>{`, which is a required argument. However, on the `}<a parentName="p" {...{
        "href": "/docs/getting-started/send-events#sending-custom-properties-on-an-event"
      }}>{`frontend`}</a>{`, a `}<inlineCode parentName="p">{`distinct_id`}</inlineCode>{` is not a required argument and thus events can be submitted anonymously. To link events from anonymous to specific users, you need to use `}<inlineCode parentName="p">{`identify`}</inlineCode>{`:`}</p>
    <MultiLanguage selector="tabs" mdxType="MultiLanguage">
      <pre><code parentName="pre" {...{
          "className": "language-javascript"
        }}>{`posthog.identify(
  'distinct_id',
  { email: 'max@hedgehogmail.com', name: 'Max Hedgehog' } 
  {}, 
);
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-Android"
        }}>{`PostHog.with(this)
     .identify(distinctID, new Properties()
        .putValue("name", "Max Hedgehog")
        .putValue("email", "max@hedgehogmail.com));
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-iOS"
        }}>{`posthog.identify("distinct_id", 
  properties: ["name": "Max Hedgehog", "email": "max@hedgehogmail.com"])
`}</code></pre>
    </MultiLanguage>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      